import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, List, ListItem, CircularProgress, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 600,
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
  p: 4,
  outline: 'none',
};

function OrderDetailModal({ summary, open, handleClose, email }) {
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (open && summary) {
      fetch(`/api/packer/getAllSummary/${email}`)
        .then(response => response.json())
        .then(data => {
          const summaryData = data.summaries.find(item => item.Summary === summary);
          setDetails(summaryData ? summaryData.details : []);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    }
  }, [open, summary, email]);

  return (
    <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box sx={style}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography id="modal-modal-title" variant="h6" component="h2" gutterBottom>
            Order Details for {summary}
          </Typography>
          <IconButton onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Typography id="modal-modal-description" variant="body1" gutterBottom>
              Total Orders: {details.length}
            </Typography>
            <List>
              {details.map((detail, index) => (
                <ListItem key={index} sx={{ borderBottom: '1px solid #ddd', py: 1 }}>
                  <Typography variant="body2">
                    Order No: {detail.find(d => d.Order_No).Order_No}
                  </Typography>
                </ListItem>
              ))}
            </List>
          </>
        )}
      </Box>
    </Modal>
  );
}

export default OrderDetailModal;